<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h3 class="text-center">
            Add and View Partnerships <span class="smh"></span>
          </h3>
        </b-col>
        <b-col>
          <div class="text-center">
            <div class="">
              <b-button
                class="v-button p-lg-2"
                @click="opencreate = true"
                variant="success"
                >Create a Partnership</b-button
              >
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="opencreate == true">
        <b-col class="m-1 p-0">
          <form @submit.prevent="addadmin">
            <b-form-group
              label="Partnership Title"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="title"
                v-model="create.title"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Partnership Description"
              label-for="title"
              class="label"
            >
              <b-form-textarea
                type="text"
                id="description"
                v-model="create.description"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Partnership Discount" label-for="markper">
              <b-form-spinbutton
                id="markper"
                v-model="create.discount"
                min="1"
                max="100"
                step="1"
              ></b-form-spinbutton>
            </b-form-group>

            <b-form-group
              label="Partnership Organization"
              label-for="title"
              class="label"
            >
              <div class="flex-input-parent">
                <div class="left-flex-child">
                  <b-form-input
                    type="text"
                    id="title"
                    v-model="create.organization"
                    @input="checkOrganization"
                  ></b-form-input>
                </div>
                <div class="right-flex-child">
                  <b-icon-x font-scale="2" variant="danger"></b-icon-x>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label="Partnership Code"
              label-for="title"
              class="label"
            >
              <div class="flex-input-parent">
                <div class="left-flex-child">
                  <b-form-input
                    type="text"
                    id="title"
                    v-model="create.code"
                    @input="checkCode"
                  ></b-form-input>
                </div>
                <div class="right-flex-child">
                  <b-icon-x font-scale="2" variant="danger"></b-icon-x>
                </div>
              </div>

              <b-button variant="success" class="mt-1" @click="generateCode"
                >Generate Code</b-button
              >
            </b-form-group>

            <b-form-group
              label="Partnership Description"
              label-for="title"
              class="label"
            >
              <vue2-tinymce-editor v-model="create.terms"></vue2-tinymce-editor>
            </b-form-group>

            <div
              v-if="sent"
              class="alert p-3"
              :class="'alert-' + addresponse.status"
            >
              {{ addresponse.msg }}
            </div>

            <b-form-group>
              <div class="text-center">
                <b-overlay
                  :show="sending"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="primary"
                  class=""
                >
                  <div class="mt-4">
                    <b-button
                      :disabled="sending"
                      type="submit"
                      variant="outline-success"
                      class="m-lg-3 mt-2 p-2 action-button"
                    >
                      Add Admin
                    </b-button>
                  </div>
                </b-overlay>
              </div>
            </b-form-group>
          </form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="">
          <h3 class="text-center">Partnerships</h3>
          <div class="text-center list-heads pt-1">
            <p class="head-p">S/N</p>
            <p class="head-p">Title</p>
            <p class="head-p">Organization</p>
            <p class="head-p">Code</p>
            <p class="head-p">Discount</p>
            <p class="head-p">Status</p>
            <p class="head-p">Terms</p>
            <p class="head-p"></p>
          </div>

          <div v-if="partnershipsarray[0].count > 0">
            <partnerships-list
              class="mt-2 maxres"
              v-for="(partnership, index) in usepartnershipsarray"
              :sn="index + 1"
              :partnership="partnership"
              :key="index"
              :page="pages"
              :interval="intervalnum"
            ></partnerships-list>
            <paginater
              v-if="partnershipsarray[0].data.length > 0"
              :intervalnum="intervalnum"
              :pages="pages"
              :endss="endss"
              :endnum="endnum"
              :datalength="endss"
              @paginator="newPage"
              @changeInterval="effectInterval"
            ></paginater>
          </div>
          <div v-else>
            <h3>No Partnership Yet</h3>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";
import partnershipsList from "@/components/admin/partnershipsList";
import Paginater from "@/components/Paginater";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
  components: {
    partnershipsList,
    Paginater,
    Vue2TinymceEditor
  },

  data() {
    return {
      create: this.getForm(),
      sending: false,
      sent: false,
      levels: [0, 1, 2, 3, 4, 5],
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      addresponse: "",
      opencreate: true
    };
  },
  beforeRouteEnter(to, from, next) {
    //   let orgname = store.state.loginmaster.details.clearance_organization
    store.dispatch("admin/fetchPartnerships").then(() => {
      next();
    });
  },
  computed: {
    ...mapState({
      users: state => state.admin.allusers,
      details: state => state.loginmaster.details,
      partnershipsarray: state => state.admin.partnerships,
      adminadded: state => state.admin.adminadded
    }),
    emails() {
      let emailss = this.users;
      return emailss.map(x => x.email);
    },
    usepartnershipsarray() {
      return this.partnershipsarray[0].data.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.partnershipsarray[0].data.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(
        this.partnershipsarray[0].data.length / this.intervalnum
      );
      return ranger;
    }
  },
  methods: {
    ...mapActions("admin", [
      "addAdmin",
      "fetchPartnerships",
      "checkPartCode",
      "checkPartOrganization",
      "generatePartCode"
    ]),
    getForm() {
      return {
        email: "",
        discount: 1,
        terms: "",
        code: "",
        title: "Admin",
        description: "",
        organization: ""
      };
    },
    addadmin() {
      this.sending = true;
      this.user.organization = this.details.clearance_organization;

      return this.addAdmin(this.user).then(response => {
        this.sending = false;
        this.sent = true;
        this.addresponse = response;
        // console.log(response)

        let orgname = {
          orgname: this.details.clearance_organization
        };
        this.fetchOrgadmins(orgname);

        this.$bvModal
          .msgBoxOk(`${this.addresponse.msg}.`, {
            title: "Operation Successful",
            size: "xs",
            centered: true
          })
          .then(() => {});
      });
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },

    checkOrganization() {
      if (this.create.organization.length > 0) {
        this.checking = true;
      } else {
        this.checking = false;
      }

      return this.checkPartOrganization(this.create.organization).then(
        response => {
          console.log(response);
        }
      );
    },

    checkCode() {
      return this.checkPartCode(this.create.code).then(response => {
        console.log(response);
      });
    }
  }
};
</script>

<style scoped>
.list-heads {
  background-color: #263056;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}
.head-p {
  width: 12%;
  padding: 2px;
}
.flex-input-parent {
  display: flex;
}
.left-flex-child {
  width: 90%;
}
.right-flex-child {
  width: 10%;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
